export var EVOLUTION_PRODUCT = {
  EvolutionCloudServer: 'evolutionCloudServer',
  EvolutionCloudServerGpu: 'evolutionCloudServerGpu',
  EvolutionCloudServerFreeTier: 'evolutionCloudServerFreeTier',
  EvolutionKubernetes: 'evolutionKubernetes',
  EvolutionStorageS3FreeTier: 'evolutionStorageS3FreeTier',
  EvolutionStorageS3: 'evolutionStorageS3',
  EvolutionManagedPostgreSQL: 'evolutionPostgreSql',
  EvolutionBareMetal: 'evolutionBareMetal',
  EvolutionContainerApps: 'evolutionContainerApps',
  EvolutionContainerAppsFreeTier: 'evolutionContainerAppsFreeTier',
  EvolutionArenadataDb: 'evolutionArenadataDb',
  EvolutionMlInference: 'evolutionMlInference'
};